<template>
    <div class="tw-container" :class="{ 'is-vertical': isVertical }" :style="style">
        <slot></slot>
    </div>
</template>

<script>
import { computed } from 'vue'

export default {
    name: 'tw-container',
    props: {
        direction: {
            type: String,
            default: ''
        },
        height: {
            type: String,
            default: '100vh'
        }
    },
    setup(props, { slots }) {
        const isVertical = computed(() => {
            if (props.direction === 'vertical') {
                return true
            } else if (props.direction === 'horizontal') {
                return false
            }
            if (slots && slots.default) {
                const vNodes = slots.default()
                return vNodes.some((vNode) => {
                    const tag = vNode.type.name
                    return tag === 'tw-header' || tag === 'tw-footer'
                })
            } else {
                return false
            }
        })
        
        return {
            isVertical,
            style: computed(
                () =>
                (props.height
                    ? {
                        '--tw-container-height': props.height,
                    }
                    : {})
            ),
        }
    },
}
</script>

<style>

</style>